import React from "react";
import { Link as RLink } from "react-router-dom";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import modulockerImg from "assets/images/modulocker.png";
import { useSession } from "context/SessionContext";

const Title = styled.span`
  font-size: 3.2rem;
  font-weight: 600;
  color: var(--black);
`;

const Link = styled(RLink)`
  font-weight: 500;
  color: #2b7de9;
`;

export default function ExpiredSession() {
  const { signOut } = useSession();
  return (
    <Grid
      container
      alignItems="center"
      style={{ background: "var(--grayLv6)", height: "100vh" }}
      justifyContent="center"
    >
      <Grid item xs={12} sm={6} style={{ textAlign: "center" }}>
        <img src={modulockerImg} alt="Modulocker" />
      </Grid>

      <Grid item xs={12} sm={6} style={{ textAlign: "center" }}>
        <Title>Sessão Expirada!</Title>
        <p>
          Por favor{" "}
          <Link to="/admin" onClick={() => signOut()}>
            clique aqui
          </Link>{" "}
          e faça o login novamente.
        </p>
      </Grid>
    </Grid>
  );
}
